export default __webpack_public_path__ + "locales/si/BackupCodesDialog.json?hash=d9af80ba70780bf8128fc1d41cc7fd8e";